import * as React from "react";

const SvgIcnGenericTaskBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M16.544 5.607c.384 0 .722.145 1.016.435.293.29.44.625.44 1.005V17.56c0 .38-.147.715-.44 1.005-.294.29-.632.435-1.016.435H6.456c-.384 0-.722-.145-1.016-.435-.293-.29-.44-.625-.44-1.005V7.047c0-.38.147-.714.44-1.005.294-.29.632-.435 1.016-.435H9.4c.113-.469.367-.854.762-1.155.395-.301.84-.452 1.337-.452s.942.15 1.337.452c.395.301.65.686.762 1.155h2.945zm-5.044.047a.683.683 0 00-.508.207.708.708 0 00-.203.517c0 .207.068.385.203.534.136.15.305.224.508.224a.657.657 0 00.508-.224.768.768 0 00.203-.534.708.708 0 00-.203-.517.683.683 0 00-.508-.207zm-1.428 9.38l-1.542-1.57a.433.433 0 00-.621.003.457.457 0 00.003.637l1.447 1.473a1 1 0 001.427 0l4.3-4.378a.457.457 0 000-.64.44.44 0 00-.629 0l-4.385 4.475z"
                fill="currentcolor"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default SvgIcnGenericTaskBold;
